<template>
  <div class="min-vh-100 d-flex flex-column">
    <router-view @strat="$emit('strat')" @tvconnect="tvconnect" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import type { IComandData } from "@/@types/connection/tvs";

@Options({
  name: "empty-layout",
})
class EmptyLayout extends Vue {
  tvconnect(command_name: string, command_data: IComandData | null): void {
    this.$emit("tvconnect", command_name, command_data);
  }
}
export default EmptyLayout;
</script>
<style lang="scss"></style>
